module.exports = __webpack_public_path__ + "static/media/5.c62d7b4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/5.jpg
// module id = 504
// module chunks = 0